import { axios } from "@/request/index";
// const COMMONAPI_SHOP = '/api/v1/merchant';

export default {
  // 草稿列表
  getDraftsList(params){
    return axios.get(`/ccam/drafts`, {params})
  },
  // 保存 草稿 或 保存到待发送
  saveDrafts(params){
    return axios.post(`/ccam/drafts`, params)
  },
  // 保存 待发送
  // sentDrafts(params){
  //   return axios.post(`/ccam/drafts/deleteSent`, params)
  // },
  // 草稿 详情
  draftsDetail(params){
    return axios.get(`/ccam/drafts/${params}`)
  },
  // 已发送 详情
  orderDetail(params){
    return axios.get(`/ccam/orders/${params}`)
  },
  // 编辑 草稿
  updateDrafts(params){
    return axios.put(`/ccam/drafts/${params.id}`, params)
  },
  // 草稿 待发送 删除
  deleteData(params){
    return axios.delete(`/ccam/drafts`, {data: params})
  },
  // 草稿 移至 待发送 
  moveSent(params){
    return axios.post(`/ccam/drafts/moveSent`, params)
  },
  // 发送 接口 
  sendCcam(params){
    return axios.post(`/ccam/drafts/sendCcam`, params)
  },
  // 发送前 校验 接口 
  checkCcamSend(params){
    return axios.post(`/ccam/drafts/checkCcamSend`, params)
  },
  // 校验船名航次
  checkShipPlan(params){
    return axios.get(`/ccam/drafts/checkShipPlan`, {params})
  },
  // 查看船代
  validateShipInfo(params){
    return axios.get(`/ccam/drafts/validateShipInfo`, {params})
  },
  // 已发送列表
  getOrderList(params){
    return axios.get(`/ccam/orders`, {params})
  },
  // 费用确认(待发送页面发送舱单)
  checkFee(params){
    return axios.post(`/ccam/drafts/checkFee`, params)
  },
  // 保存客户
  saveCustoms(params){
    return axios.post(`/ccam/customs`, params)
  },
  // 获取 客户
  getCustoms(params){
    return axios.get(`/ccam/customs`, {params})
  },
  // 查询船imo
  getImo(params){
    return axios.get(`/ccam/drafts/queryShipImo`, {params})
  },
  // 提交人 列表
  getSubmitUserList(params){
    return axios.get(`/ccam/customs/submitUserList`, {params})
  },
  // 改单费用确认
  checkUpdateFee(params){
    return axios.get(`/ccam/orders/checkUpdateFee`, {params})
  },
  // 修改舱单
  updateSend(params){
    return axios.post(`/ccam/orders/updateSend`, params)
  },
  // 舱单草稿/待发送列表导出
  exportDraft(params){
    // return axios.get(`/ccam/export/draft`, {params})
    return axios({
      method: 'get',
      url: '/ccam/export/draft',
      params: params,
      responseType: "blob"
    })
  },
  // 舱单已发送/改单/删单列表导出
  exportOrder(params){
    return axios({
      method: 'get',
      url: '/ccam/export',
      params: params,
      responseType: "blob"
    })
  },
  // 删单费用确认
  deleteFee(params){
    console.log(params)
    return axios.get(`/ccam/orders/checkDeleteFee`, {params})
  },
  // 删单
  deleteSend(params){
    return axios.post(`/ccam/orders/deleteSend`, params)
  },
  // 获取海关总署
  queryCustoms(params){
    return axios.get(`/ccam/orders/queryCustoms`, {params})
  },
  // 获取装载回执 
  queryLoadingStatus(params){
    return axios.get(`/ccam/orders/queryLoadingStatus`, {params})
  },
  // 根据船公司获取船公司代理
  agentByCarrier(params){
    return axios.get(`/ccam/carriers/agentByCarrier`, {params})
  },
  // 柜面删单可选提单号
  getCounterDeleteHouseBillNoList(params){
    return axios.get(`/ccam/orders/counterDeleteHouseBillNoList`, {params})
  },
  // 柜面删单
  counterDelete(params){
    return axios.post(`/ccam/orders/counterDelete`, {params})
  },
  // 柜面详情 详情
  counterDetail(params){
    return axios.get(`/ccam/orders/counterDetail/${params}`)
  },
  // 用户是否首次使用舱单
  firstUseCcam(){
    return axios.get(`/ccam/drafts/firstUseCcam`)
  },
  // CB开头提单号对应船公司
  getCarrierSimpleByMasterBillNo(params){
    return axios.get(`/ccam/carriers/getCarrierSimpleByMasterBillNo`, {params})
  },
  // vgm 导流
  ccamSendVGM(params){
    return axios.get(`/ccam/orders/ccamSendVGM/${params}`)
  },
  // vgm 是否支持舱单导流
  isCcamSendVGM(params){
    return axios.get(`/ccam/orders/isCcamSendVGM/${params}`)
  },



}
